<template>
  <div class="first-rank" v-if="data && data.length">
    <div
      class="rank-item"
      @click="bindInto(item)"
      :class="['rank-item-' + index]"
      v-for="(item, index) in data"
      :key="index"
    >
      <img class="bg-image" :src="bgImageList[index]" alt="" />
      <div class="rank-item-avatar">
        <img class="avatar" :src="item.coach_image" alt="" />
        <span class="main-text" v-if="item.is_head_coach">主教练</span>
        <img
          class="crown"
          :class="{ 'crown-scale': index == 0 }"
          :src="crownList[index]"
          alt=""
        />
      </div>
      <div class="coach-name">{{ item.coach_name }}</div>
      <div class="send-container">
        <div class="you-send" v-if="isMember"
          >已送给Ta
          <span :class="{ 'you-send-num': item.gift_num }"
            >{{ item.gift_num || 0 }}朵</span
          ></div
        >
        <div v-else class="item-store-name">{{ item.store_name }}</div>
      </div>
      <div class="flower-total">
        <img
          class="flower-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
          alt=""
        />
        <div class="flower-num">{{ item.vote_num }}</div>
      </div>
      <div class="rank-item-focus-content">
        <div class="rank-item-focus" v-if="showFocus && !item.is_me">
          <div
            v-if="!item.is_follow"
            class="not-focus-btn"
            @click.stop="bindFocus(item)"
          >
            <img
              class="iconfont"
              src="https://btw-common-data.betterwestar.com/btw-admin/resource/7d34203215ba29db4a57afc20b678b66_wh=27_27.png"
              alt=""
            />
            <span>关注</span>
          </div>
          <div v-else class="is-focus-btn">已关注</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isMember: {
      type: Boolean,
      default: true
    },
    showFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      crownList: [
        'https://btw-common-data.betterwestar.com/btw-admin/resource/5fa0c05b632f6c5c3f8f4807208f5c68_wh=381_315.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/8f4ba118574c5a1492587de5487c41a6_wh=108_99.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/0b499c57a547586cddb79488088c47f7_wh=108_99.png'
      ],
      bgImageList: [
        'https://btw-common-data.betterwestar.com/btw-admin/resource/803f91662a0bd4b1b9e3cc9f1872322e_wh=405_714.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/1530adb398dab12351cdeadaf74ae55a_wh=312_609.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/70855b26b0f562a38446e8ab39c736f9_wh=312_609.png'
      ]
    }
  },
  created() {},
  methods: {
    bindInto(item) {
      let id = item.coach_id
      if (id) {
        this.$betterwe.jumpRoute('/userDetailsPage?id=' + id)
      }
    },
    async bindFocus(item) {
      let params = {
        unify_id: item.coach_id,
        flag: 1
      }
      let res = await this.$http
        .postBaseApp('member/appCamp/optionFollow', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('关注成功')
          item.is_follow = 1
          //this.$store.commit('coachActivity2024/setCoachFocusByUid', item.coach_id);
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.first-rank {
  position: relative;
  box-sizing: border-box;
  margin-bottom: 20px;
  height: 292px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .rank-item {
    z-index: 1;
    box-sizing: border-box;
    padding-bottom: 48px;
    text-align: center;
    width: 96px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .bg-image {
      width: 104px;
      height: 203px;
      object-fit: contain;
      position: absolute;
      left: 50%;
      top: -4px;
      transform: translate(-50%, 0%);
      z-index: -1;
    }
    .rank-item-avatar {
      margin-top: -27px;
      width: 54px;
      height: 54px;
      position: relative;
      margin-bottom: 4px;
      .first-flag {
        position: absolute;
        width: 127px;
        height: 105px;
        left: 50%;
        top: 43%;
        transform: translate(-50%, -50%);
      }
      .crown {
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-24%, -55%);
        width: 36px;
        height: 33px;
      }
      .crown-scale {
        position: absolute;
        width: 127px;
        height: 105px;
        left: 50%;
        top: 43%;
        transform: translate(-50%, -50%);
      }
      .avatar {
        box-sizing: border-box;
        object-fit: cover;
        border: 2px solid #ffffff;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
      }
      .main-text {
        white-space: nowrap;
        position: absolute;
        z-index: 1;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0%);
        height: 15px;
        background: #f64372;
        border-radius: 8px;
        font-weight: bold;
        font-size: 10px;
        color: #ffffff;
        line-height: 15px;
        padding: 0px 10px;
      }
    }
    .coach-name {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: bold;
      font-size: 16px;
      color: #5e6874;
      line-height: 22px;
    }
    .send-container {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 4px 0px -2px;
    }
    .you-send {
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 16px;
      margin-bottom: 2px;
      .you-send-num {
        color: rgba(255, 34, 112, 1);
      }
    }
    .item-store-name {
      padding: 0px 20px;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 16px;
    }
    .flower-total {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .flower-image {
        width: 15px;
        height: 15px;
        object-fit: contain;
      }
      .flower-num {
        font-family: DIN;
        font-weight: bold;
        font-size: 20px;
        color: #ff2270;
        line-height: 26px;
      }
    }
    .rank-item-focus-content {
      height: 28px;
    }
    .rank-item-focus {
      .not-focus-btn {
        box-sizing: border-box;
        width: 72px;
        height: 28px;
        background: #ffffff;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 12px;
        color: #050b27;
        .iconfont {
          width: 9px;
          height: 9px;
          object-fit: contain;
          margin-right: 6px;
        }
      }
      .is-focus-btn {
        width: 72px;
        height: 28px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: normal;
        font-size: 12px;
        color: rgba(5, 11, 39, 0.3);
        line-height: 28px;
      }
    }
  }
  .rank-item-1 {
    position: absolute;
    bottom: 0;
    left: 0%;
  }
  .rank-item-0 {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 127px;
    padding-bottom: 48px;
    .send-container {
      margin-bottom: -2px;
    }
    .bg-image {
      width: 135px;
      height: 238px;
      top: -6px;
    }
    .rank-item-avatar {
      margin-top: -39px;
      width: 78px;
      height: 78px;
      margin-bottom: 12px;
    }
    .coach-name {
      font-weight: bold;
      font-size: 18px;
      color: #ea7a00;
      line-height: 25px;
    }
    .flower-total {
      margin-bottom: 6px;
      .flower-image {
        width: 20px;
        height: 20px;
      }
      .flower-num {
        font-size: 27px;
        line-height: 34px;
      }
    }
  }
  .rank-item-2 {
    position: absolute;
    bottom: 0;
    right: 0%;
    .coach-name {
      color: rgba(165, 55, 57, 1);
    }
  }
}
</style>
